import React from 'react';
import { uniqueKey } from "../../common/keys";

export const mapMarkers = (mrks, t) => mrks.map((marker, index) => (
  marker && marker.position ? <MapMarker
    key={uniqueKey('mm', t, index)}
    lat={marker.position.lat}
    lng={marker.position.lng}
    marker={marker}
  /> : null
))


export const MapMarker = ({ marker }) => {
  const { backgroundColor, color, text, title, url: iconUrl, index } = marker ?? {}
  if (iconUrl) {
    return <div key={uniqueKey('gmi', index)} title={title} className={'google-url'} style={{ color, backgroundImage: `url(${iconUrl})`, backgroundRepeat: 'no-repeat' }}>
      {text}
    </div>
  } else {
    return <div key={uniqueKey('gmi', index)} title={title} className={'google-dot'} style={{ backgroundColor, color }}>
      {text}
    </div>
  }
}

export const MapWindow = ({ marker, oc, occ }) => {
  const { index, title, name } = marker ?? {}
  return <div key={uniqueKey('gmif', index)} title={title} className={'info-window'} onClick={(e) => occ && occ(marker)}>
    <div onClick={(e) => oc && oc(e)}>{'X'}</div>
    <div>{name ? name : title}</div>
  </div>
}
